import {
	MessageActionCopyClipboard,
	MessageActions,
	MessageActionSources,
} from "@virtual-brain-lib/frontend-design-system/components";
import type { ChatMessage } from "@virtual-brain-lib/types";

export function ChatbotAppMessageActions({ message }: { readonly message: ChatMessage }) {
	if (message.role === "user") {
		return (
			<MessageActions align="right">
				{message.content && <MessageActionCopyClipboard messageContent={message.content} />}
			</MessageActions>
		);
	}

	if (message.role === "assistant" && message.status === "processed" && message.content) {
		return (
			<MessageActions align="chatbotleft">
				<MessageActionCopyClipboard messageContent={message.content} />
				<MessageActionSources message={message} />
			</MessageActions>
		);
	}

	return null;
}
